import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const generateImgixUrl = (url) => {
  if (url == null) {
    return '';
  }
  
  const res = url.replace('https://s3.amazonaws.com/developertool/', 'https://imgtravpromobile.imgix.net/');
  const returnValue = res + '?fit=clip&w=200&h=auto';
  return returnValue;
};

const ContactViewCard = ({ name, title, telephone, address, mail, imageUrl }) => {
  return (
    <div className="contactView">
      <div className="contactView__Content">
        <img className="headshot" src={generateImgixUrl(imageUrl)} alt={`${name} - ${name}`} />
        <h1>{name}</h1>
        <h2>{title}</h2>
        {address !== '///' && <p>{address && <strong>{address}</strong>}</p>}
        <a href={`tel:${telephone.trim()}`}>
          <FontAwesomeIcon icon={['fas', 'phone']} />{telephone}
        </a>
        <a href={`mailto:${mail.emails[0].email}`}>
          <FontAwesomeIcon icon={['fas', 'envelope']} />
          {mail.emails[0].email}
        </a>
      </div>
    </div>
  );
};

export default ContactViewCard;
